import { FormControlLabel, FormHelperText } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import Checkbox from "./Checkbox";

export default function CheckboxField(props) {
  const { name, label, labelSx, defaultValue = false, rules, ...rest } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
        <>
          <FormControlLabel
            label={label}
            sx={{
              ".MuiFormControlLabel-label ": {
                fontSize: "16px",
                color: "black",
                fontWeight: 400,
                ...labelSx,
              },
            }}
            control={
              <Checkbox
                checked={value}
                onChange={(e) => onChange(e.target.checked)}
                inputRef={ref}
                color="primary"
                {...rest}
              />
            }
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
}
